// extracted by mini-css-extract-plugin
export default {"rectangle6Container":"RectangleFrame_rectangle6Container__7YaOn","rectangle6ContainerParent":"RectangleFrame_rectangle6ContainerParent__c-mGd"};